// src/components/ClaimCompensations.jsx
import React from "react";
import s71 from "./s71.svg";
import s72 from "./s72.svg";
import s73 from "./s73.svg";
import s74 from "./s74.svg";
import s75 from "./s75.svg";
import s76 from "./s76.svg";
import s77 from "./s77.svg";
import s78 from "./s78.svg";

/**
 * ClaimCompensations
 * - Responsive grid: 1 / 2 / 4 columns
 * - Icons are file SVGs (s71.svg ... s78.svg) located in the same folder
 * - Cards are center aligned, narrow width to match screenshot spacing
 */
export default function Sectionseven() {
  const items = [
    {
      id: 1,
      title: "Medical Bills",
      desc: "ER visits, surgery, follow-ups, and ongoing care related to your injuries.",
      icon: s71,
    },
    {
      id: 2,
      title: "Pain and Suffering",
      desc: "Compensation for physical pain and emotional distress from the crash.",
      icon: s72,
    },
    {
      id: 3,
      title: "Lost Wages",
      desc: "Coverage for work days missed due to injury, treatment, or recovery time.",
      icon: s73,
    },
    {
      id: 4,
      title: "Property Damage",
      desc: "Repairs or replacement for your vehicle and any belongings inside it.",
      icon: s74,
    },
    {
      id: 5,
      title: "Lost Employment Opportunities",
      desc: "If your injuries prevent future job prospects or advancement.",
      icon: s75,
    },
    {
      id: 6,
      title: "Ambulance Bills",
      desc: "Emergency transport costs and hospital admittance fees.",
      icon: s76,
    },
    {
      id: 7,
      title: "Physical Therapy",
      desc: "Recovery services like rehab, occupational therapy, or long-term mobility care.",
      icon: s77,
    },
    {
      id: 8,
      title: "Anxiety and Mental Health Strain",
      desc: "PTSD, anxiety, and other lasting emotional impacts of the crash.",
      icon: s78,
    },
  ];

  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-3xl md:text-4xl lg:text-5xl font-extrabold text-red-700">
          What Can I Get From a Car Accident Claim?
        </h2>

        <p className="text-center text-sm md:text-base text-gray-700 mt-3 max-w-3xl mx-auto">
          A successful injury claim may include compensation for:
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8 place-items-center">
          {items.map((it) => (
            <div key={it.id} className="text-center max-w-[220px]">
              <div className="mx-auto text-red-700">
                {/* Use img so you can swap files later; keep aria-hidden to match decorative role */}
                <img src={it.icon} alt="" aria-hidden className="w-12 h-12 mx-auto object-contain" />
              </div>

              <h3 className="mt-4 font-semibold text-sm text-gray-800">
                {it.title}
              </h3>

              <p className="mt-2 text-xs md:text-sm text-gray-600 leading-6">
                {it.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <button className="bg-red-700 text-white px-8 py-3 rounded-md font-semibold shadow hover:-translate-y-0.5 transform transition"
          onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}>
            Get My Free Lawsuit Case Review
          </button>
        </div>
      </div>
    </section>
  );
}
